import React from 'react';

export default function StatusPill({ label, tone = 'neutral' }) {
  return <span className={`wt-status-pill wt-status-pill--${tone}`}>{label}</span>;
}
